import React from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Moment from 'moment'
import { FORMAT_DATE_TRUNC } from 'constants/config'

const CommercialManagement = (props) => {
  const { translate, getCsv, newSearch, filters, values } = props

  return (
    <div className='commercialManagements-page container-mobile'>
      <div className='margin-left-double margin-right-double marginTop'>
        <Row className='margin-bottom-double padding-bottom-double'>
          <div className='center'>
            <Col xs={12} sm={12} md={6}>
              <div className='rectangle border rounded padding-top-double'>
                <h3 className='text color-text'>
                  {translate('commercialManagements.date.query.report')}
                </h3>

                <div>
                  <span className='highlighted-date'>{`${Moment(
                    Date.now()
                  ).format(FORMAT_DATE_TRUNC)}`}</span>
                </div>
              </div>
            </Col>

            <Col xs={12} sm={12} md={6}>
              <div className='rectangle border rounded padding-top-double'>
                <h3 className='text color-text'>
                  {translate('commercialManagements.period')}
                </h3>
                <div>
                  <span className='highlighted-date'>
                    {values && !filters &&
                      (values.dtStart ? values.dtStart : '') +
                      (values.dtEnd || !values.dtStart ? ' - ' : '') +
                      (values.dtEnd ? values.dtEnd : '')
                    }
                  </span>
                </div>
              </div>
            </Col>
          </div>
        </Row>
      </div>

      {/*
        <div className='margin-left-double margin-right-double'>
          <Col xs={12} className='margin-bottom-double padding-bottom-double'>
            <Col xs={12} sm={6} md={3}>
              <div className='rectangle border rounded'>
                <div className='circular wrap'>
                  <i className='commercialManagement' />
                </div>
                <h4 className='heading-4 uppercase title'>{translate('commercialManagements.commercialManagementTitle')}</h4>
                <div>
                  <span className='highlighted-number'>{translate('commercialManagements.coin') + ' ' + Mask.toMoney(commercialManagement.totalMargin.toFixed(2))}</span>
                </div>
                <p className='text'>{translate('commercialManagements.commercialManagementsText')}</p>
              </div>
            </Col>

            <Col xs={12} sm={6} md={3}>
              <div className='rectangle border rounded'>
                <div className='circular wrap'>
                  <i className='pallets' />
                </div>
                <h4 className='heading-4 uppercase title'>{translate('commercialManagements.palletsTitle')}</h4>
                <div>
                  <span className='highlighted-number'>{commercialManagement.totalStock + ' ' + translate('commercialManagements.LMS')}</span>
                </div>
                <p className='text'>{translate('commercialManagements.palletsText')}</p>
              </div>
            </Col>

            <Col xs={12} sm={6} md={3}>
              <div className='rectangle border rounded'>
                <div className='circular wrap'>
                  <i className='dollar' />
                </div>
                <h4 className='heading-4 uppercase title'>{translate('commercialManagement.dollarTitle')}</h4>
                <div>
                  <span className='highlighted-number'>{translate('commercialManagements.coin') + ' ' + Mask.toMoney(commercialManagement.totalSale.toFixed(2))}</span>
                </div>
                <p className='text'>{translate('commercialManagement.dollarText')}</p>
              </div>
            </Col>

            <Col xs={12} sm={6} md={3}>
              <div className='rectangle border rounded'>
                <div className='circular wrap'>
                  <i className='truck' />
                </div>
                <h4 className='heading-4 uppercase title'>{translate('commercialManagement.truckTitle')}</h4>
                <div>
                  <span className='highlighted-number'>{commercialManagement.totalProductCD + ' ' + translate('commercialManagements.LMS')}</span>
                </div>
                <p className='text'>{translate('commercialManagement.truckText')}</p>
              </div>
            </Col>
          </Col>
        </div>
      */}

      {/* <Row className='margin-top-double margin-bottom'>
        <Col xs={12} md={6} />
      </Row> */}

      <div className='margin-left-double margin-right-double'>
        <Row>
          <div className='center'>
            <Col xs={12} md={6}>
              <button
                type='button'
                onClick={newSearch}
                className='button button-default button-full margin-bottom'
              >
                {translate('commercialManagements.newSearch')}
              </button>
            </Col>

            <Col xs={12} md={6}>
              <button
                type='button'
                onClick={getCsv}
                className='button button-primary button-full margin-bottom'
              >
                {translate('commercialManagements.excelReport')}
              </button>
            </Col>

            {/*
            <Col xs={6} md={3}>
              <button
                type='button'
                onClick={getPdf}
                className='button button-primary button-full'
              >
                {translate('commercialManagements.pdfReport')}
              </button>
            </Col>
            */}
          </div>
        </Row>
      </div>
    </div>
  )
}

CommercialManagement.propTypes = {
  translate: PropTypes.func.isRequired,
  commercialManagement: PropTypes.object.isRequired,
  getCsv: PropTypes.func.isRequired,
  newSearch: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
}

export default CommercialManagement
